import { useRouter, NextRouter } from 'next/router'

interface Hooks {
  nextRoute: NextRouter
}

export function useHooks(): Hooks {
  const nextRoute = useRouter()
  return { nextRoute }
}
